import React from "react";
import './ServiceFlow.css';
const ServiceFlow = () => {
    const services = [
        {
            number: 1,
            title: 'ヒアリング',
            description: 'お客様のビジネス目標、ターゲット層、課題を詳しくヒアリングします。'
        },
        {
            number: 2,
            title: '戦略立案',
            description: '最適なWeb広告戦略を立案し、効果的なプランを提案します。'
        },
        {
            number: 3,
            title: '実施・運用',
            description: '広告配信を開始し、継続的に効果を最大化する運用を行います。'
        },
        {
            number: 4,
            title: 'レポート',
            description: '　定期的に詳細なレポートを提供し、成果を可視化します。　　'
        }
    ];

    return (
        <section className="service-flow">
            {/* Wave shapes at top */}
            <div className="wave-top-purple"></div>
            <div className="wave-top-coral"></div>
            
            <div className="service-flow-container">
                <h2 className="service-flow-title">サービスのご案内</h2>
                
                <div className="service-steps">
                    {services.map((service, index) => (
                        <React.Fragment key={service.number}>
                            <div className="step-item">
                                <div className={`step-badge step-badge-${service.number}`}>
                                    {service.number}
                                </div>
                                <div className="step-label">STEP {service.number}</div>
                                <h3 className="step-title">{service.title}</h3>
                                <p className="step-description">{service.description}</p>
                            </div>
                            {index < services.length - 1 && (
                                <div className="step-arrow">→</div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceFlow;
